import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccessCodeGeneratorComponent } from './component/access-code-generator/access-code-generator.component';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { JobsComponent } from './component/jobs/jobs.component';
import { UpdatejobsComponent } from './component/jobs/updatejobs/updatejobs.component';
import { LoginComponent } from './component/login/login.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'jobs', component: JobsComponent },
  { path: 'updatejobs', component: UpdatejobsComponent },
  { path: 'accesscodegenerator03182021', component: AccessCodeGeneratorComponent },
  { path: 'login', component: LoginComponent },
  { path: '', component: DashboardComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
